import { defineStore } from "pinia";
import { TalkRoom } from "~/entities/TalkRoom";
import { TalkRoomEditInfo } from "~/entities/TalkRoomEditInfo";
import { TalkRoomDisplayOrder } from "~/entities/TalkRoomDisplayOrder";
import type { ITalkRoomEditRepository } from "~/interfaces/ITalkRoomEditRepository";
import { TalkRoomEditRepository } from "~/repositories/TalkRoomEditRepository";

export const useTalkRoomEditStore = defineStore("TalkRoomEditStore", () => {
  const repository: ITalkRoomEditRepository = new TalkRoomEditRepository();
  const talkRoomEditInfo = ref<TalkRoomEditInfo | null>(null);
  const loading = ref(false);

  const init = (nextDisplayOrder: number) => {
    talkRoomEditInfo.value = TalkRoomEditInfo.fromNextDisplayOrder(nextDisplayOrder);
  };

  const initBy = (talkRoom: TalkRoom) => {
    talkRoomEditInfo.value = TalkRoomEditInfo.fromTalkRoom(talkRoom);
  };

  const createTalkRoom = async (planId: string, talkRoomEditInfo: TalkRoomEditInfo) => {
    loading.value = true;
    try {
      return await repository.createTalkRoom(planId, talkRoomEditInfo);
    } finally {
      loading.value = false;
    }
  };

  const updateTalkRoom = async (talkRoomId: string, talkRoomEditInfo: TalkRoomEditInfo) => {
    loading.value = true;
    try {
      await repository.updateTalkRoom(talkRoomId, talkRoomEditInfo);
    } finally {
      loading.value = false;
    }
  };

  const deleteTalkRoom = async (talkRoomId: string) => {
    loading.value = true;
    try {
      await repository.deleteTalkRoom(talkRoomId);
    } finally {
      loading.value = false;
    }
  };

  const setDisplayOrders = async (displayOrders: TalkRoomDisplayOrder[]) => {
    loading.value = true;
    try {
      await repository.setDisplayOrders(displayOrders);
    } finally {
      loading.value = false;
    }
  };

  return {
    talkRoomEditInfo,
    loading,
    init,
    initBy,
    createTalkRoom,
    updateTalkRoom,
    deleteTalkRoom,
    setDisplayOrders,
  };
});
